/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

export const sellerServiceUrl ='https://seller.ctbids.com/services';
export const buyerServiceUrl = 'https://ctbids.com/services';
export const adminServiceUrl = "https://admin.ctbids.com/services";
export const paymentServiceUrl = "https://payments.ctbids.com/services";

//membership
export const membershipbaseurl = "https://membership.ctbids.com/services/"
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
// ===================================================== Buyers API ================================================================ //
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

// Auth
export const buyerLogIn = "/api/v1/buyer/auth/token";
export const buyerUserDetail = "/api/v1/buyer/user/detail";
export const refreshToken = "/api/v1/buyer/token/refresh";
export const register = "/api/v1/buyer/user/register";
export const userUpdate = "/api/v1/buyer/user/update";
export const passwordChange = "/api/v1/buyer/user/password/change";
export const emailChange = "/api/v1/buyer/user/email/change";
export const verifyEmail = "/api/v1/buyer/user/email/change/verification/request";
export const passwordSet = "/api/v1/buyer/user/password/set";
export const mobileNoChange = "/api/v1/buyer/user/mobile/change";
export const resendOtp = "/api/v1/buyer/user/mobile/change/verification/request";
export const verifyOtp = "/api/v1/buyer/user/mobile/change/verify/";
export const externalAuth = "/api/v1/buyer/external/auth/token";
export const userVerify = "/api/v1/buyer/user/verify";
export const userDelete = '/api/v1/buyer/user/delete';
export const mobileNumberValid = '/api/v1/buyer/user/mobile/validate';
export const verifyMobileOtp = '/api/v1/buyer/user/mobile/otp';
export const checkOtp = '/api/v1/buyer/user/mobile/otp/verify';
export const resendPhoneOtp = '/api/v1/buyer/user/mobile/otp/resend';
export const reactivation = '/api/v1/buyer/user/buyer/reactivate'
export const updateuser = '/api/v1/buyer/user/update/buyer';
export const bannedwords = '/api/v1/buyer/ai/banned/words';

// Address
export const stateList = "/api/v1/buyer/address/state/list";
export const cityList = "/api/v1/buyer/address/city/list/";
export const zipCodeDetails = "/api/v1/buyer/address/zipcode/detail/";

// Social media
export const googleSocialMediaCheck = "/api/v1/buyer/user/integration/scm/oauth/google/email/exist";
export const googleSocialMedia = "/api/v2/buyer/user/integration/scm/oauth/google";
export const facebookSocialMediaCheck = "/api/v1/buyer/user/integration/scm/oauth/facebook/email/exist";
export const facebookSocialMedia = "/api/v2/buyer/user/integration/scm/oauth/facebook";
export const appleSocialMediaCheck = "/api/v1/buyer/user/integration/scm/oauth/apple/email/exist";
export const appleSocialMedia = "/api/v2/buyer/user/integration/scm/oauth/apple";

// Watch
export const watchList = "/api/v1/buyer/wishlist/list";
export const addWatch = "/api/v1/buyer/wishlist/add";
export const removeWatch = "/api/v1/buyer/wishlist/delete";
export const watchListItem = "/api/v1/buyer/wishlist/item/list";

// Invoice
export const invoicePrintPdf = '/api/v1/buyer/invoice/pdf/view';
export const invoiceList = "/api/v1/buyer/invoice/list";
export const invoiceDetail = "/api/v1/buyer/invoice/detail";
export const transactionHistory = "/api/v1/buyer/payment/transaction/list";

// Payment
export const orderAdd = "/api/v1/buyer/payment/order/add";
export const orderUpdate = "/api/v1/buyer/payment/order/update";
export const invoiceOrderDetail = "/api/v1/buyer/payment/order/detail/invoice";
export const cancelInvoiceOrder = "/api/v1/buyer/payment/order/cancel/invoice";
export const paymentSuccess = "/api/v1/buyer/payment/add";

export const buynowAdd = "/api/v1/buyer/payment/order/add";
export const buynowDetail = "/api/v1/buyer/payment/order/detail/item";
export const cancelBuynowOrder = "/api/v1/buyer/payment/order/cancel/item";
export const itemReceiptAdd = '/api/v1/buyer/item/receipt/add';
export const itemReceiptGet = '/api/v1/buyer/item/receipt/view';
export const receiptCheck = "/api/v1/buyer/invoice/item/receipt";
export const bidderAccept = "/api/v1/buyer/invoice/bidder/acceptance"

// Bid
export const placeBid = "/api/v1/buyer/auction/bid";
export const bidHistory = "/api/v1/buyer/auction/bid/history/";
export const bidHistoryForWonAndNotWon = "/api/v1/buyer/auction/bid/history/closed/item/";

// Sale, item
export const saleClosing = "/api/v1/buyer/auction/sale/item/closing/time/";
export const currentBidValue = "/api/v1/buyer/auction/item/current/bid";
export const commonUTCForSale = "/api/v1/buyer/time/utc";
export const itemBuyNowPrice = "/api/v1/buyer/auction/item/price/detail/";

// Bidding, watching, won, not-won
export const bidding = "/api/v1/buyer/completed/auction/bidding/not/won";
export const won = "/api/v1/buyer/completed/auction/bid/won";
export const notwon = "/api/v1/buyer/completed/auction/bid/not/won";

// Notification Preference
export const notificationPreferenceList = "/api/v1/buyer/preference/list";
export const notificationPreferenceAdd = "/api/v1/buyer/preference/add";
export const notificationPreferenceUpdate = "/api/v1/buyer/preference/update";

export const biddernotificationList = "/api/v1/buyer/notification/list";
export const updateNotication = "/api/v1/buyer/notification/update";

// Tax Excemption
export const taxFileList = "/api/v1/buyer/tax/exempt/file/list";
export const taxFileUpload = "/api/v1/buyer/tax/exempt/file/upload";
export const taxFileDelete = "/api/v1/buyer/tax/exempt/file/delete";
export const exemptionList = "/api/v1/buyer/tax/exempt/list";

// Fragment Upload
export const fileUpload = '/api/v1/buyer/file/upload';
export const fileUploadFragment = '/api/v1/buyer/file/upload/fragment';

// Message
export const messageAdd = "/api/v1/buyer/item/message/add";
export const messagePublicList = "/api/v1/buyer/item/message/list";
export const messageAuthList = "/api/v1/buyer/item/message/user/list";

// SSE event
export const bidsSseEvent = "/api/v1/buyer/sse/bids/";
export const bidsSseEventAdd = "/api/v1/buyer/sse/bids/item/add/";
export const notificationSseEvent = "/api/v1/payment/sse/triggerevent/buyer/";

// UTC time
export const getUTCTime = "/api/v1/buyer/time/utc";

//suspended list
export const suspendList = "/api/v1/buyer/user/suspend/list"

// Locations
export const favoriteLocationAdd = "/api/v1/buyer/favlocation/add";
export const favoriteLocationDelete = "/api/v1/buyer/favlocation/delete";
export const favoriteLocationList = "/api/v1/buyer/favlocation/list";
export const seoLocationList = "/api/v1/buyer/seolocation/list";

// Archive
export const wonAddArchive = "/api/v1/buyer/completed/auction/bid/won/archive";
export const notWonAddArchive = "/api/v1/buyer/completed/auction/bid/not/won/archive";

// Banner Text
export const webcontent = "/api/v1/webcontent/list/";

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
// ===================================================== Seller API ================================================================ //
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

// Auth, User
export const login = "/api/v1/auth/token";
export const connectToken = "/api/v1/connect/token";
export const userDetail = "/api/v1/user/detail";


// Sale
export const salesList = "/api/v1/search/sale/list";
export const saleImageList = "/api/v1/search/sale/image/list";
export const saleDetails = "/api/v1/search/sale/detail/";

// Item
export const itemsList = "/api/v1/search/item/new/list";
export const exploreItemList = "/api/v1/search/explore/item/list";
export const sneakPeak = "/api/v1/buyer/sneakpeek/item/list"
export const itemDetails = "/api/v1/search/item/detail/";
export const itemImageList = "/api/v1/search/item/image/list";
export const itemsNLP = "/api/v1/nlp/search/item/mobile";
export const addCount = "/api/v1/search/item/add/view/count";
export const searchItemsList = "/api/v1/search/item/search/list";
export const deleteUserValid = '/api/v1/buyer/user/delete/validate';
export const wonAndNotWonitemsList = "/api/v1/search/buyer/item/list";
export const itemShopWithCard = "/api/v1/shopwithpurpose/list";
// Location 
export const locationDetails = "/api/v1/search/location/detail/";
export const locationList = "/api/v1/search/location/list";
export const locationAllList = "/api/v1/search/location/inactive/detail";
export const locationInactiveList = "/api/v1/search/location/inactive/list";
export const locationImageList = "/api/v1/search/location/image/list";

// Category, Area
export const categoryList = "/api/v1/category/list";
export const categoryCount = "/api/v1/search/item/category/count";
export const categoryWithSubList = "/api/v1/category/new/list";
export const categorySelectionList = "/api/v1/category/selection/list";
export const areaCount = "/api/v1/search/item/area/count";

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
// ====================================================== Admin API ================================================================ //
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

export const adminToken = "/api/v1/admin/auth/token";
export const buyerToken = "/api/v1/admin/buyer/token";

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //
// ====================================================== Payments API ================================================================ //
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ //

export const paymentToken = "/api/v1/buyer/payment/token";

// Vault card
export const vaultCardList = '/api/v1/buyer/vault/card/list';
export const vaultCardAdd = '/api/v1/buyer/vault/card/add';
export const vaultCardDelete = '/api/v1/buyer/vault/card/delete';
export const vaultCardDefault = '/api/v1/buyer/vault/card/change/default';
export const vaultCardAudit = '/api/v1/buyer/vault/card/audit/add';

export const giftAdd = '/api/v1/buyer/mystery/gifts/add';
export const giftEntryVerify = '/api/v1/buyer/mystery/gifts/verify';

// auto debit api
export const autoDebitPayment = '/api/v1/buyer/vault/auto/debit/item';
export const autoDebitVaultList = '/api/v1/buyer/vault/card/list';

// Category url
export const categoryDetail = "/api/v1/buyer/seolocation/category/detail";

//paypal vault
export const vaultPayPalAccount = "/api/v1/buyer/vault/paypal/account/add";
export const vaultCardVerify = "/api/v1/buyer/vault/card/verify";

// Shipping update
export const shippingAddressCreate = "/api/v1/buyer/address/create";
export const shippingAddressUpdate = "/api/v1/buyer/address/update";
export const shippingAddressList = "/api/v1/buyer/address/list";
export const shippingAddressDetail = "/api/v1/buyer/address/detail/";
export const shippingAddressDelete = "/api/v1/buyer/address/delete";
export const advlist = "/api/v1/buyer/advertise/list";

// City/State check
export const stateCityCheck = "/api/v1/buyer/address/check/city";

// contract list
export const contractList = "/api/v1/buyer/seel/contract/list"

// Seel detail
export const seelDetailsData = "/api/v1/buyer/ra/seel/quote";
export const seelGDDetailsData = "/api/v1/buyer/gd/seel/quote";

// IRM Details
export const irmDetails = "/api/v1/buyer/item/receipt/detail/";

// Eligible Category and location
export const eligibleCategoryandLocation = "/api/v1/static/content/view";

export const membershipCategoryAdd = '/api/v1/buyer/aoi/add';
export const membershipCategoryUpdate = '/api/v1/buyer/aoi/update';
export const membershipCategoryList = "/api/v1/buyer/aoi/list";
export const membershipCategoryDetail = '/api/v1/buyer/aoi/detail'

//membership plan

export const membershipPlan = "/api/v1/buyer/membership/plan/list";
export const preview = "/api/v1/buyer/search/item/list/preview/";
export const advisorAdd = "/api/v1/buyer/premierAdvisor/add";
export const content = "/api/v1/buyer/content/list";
export const memberShipAdd = "/api/v1/buyer/membership/add";
export const itemDetail = "/api/v1/buyer/membership/item/detail/";
export const applyCouponCode = "/api/v1/buyer/coupon/apply";
export const membershipList = '/api/v1/buyer/membership/list';
export const membershipUpdate = '/api/v1/buyer/membership/update';

//fullfillmentlist
export  const fullfillmentlist = "/api/v1/buyer/seel/fulfillment/list";

// Jira knowledge base
export const jiraKnowledge = "/api/v1/buyer/jira/knowledge/base/";
export const FAQList = "/api/v1/faq/search/keylist";
export const premierFAQ = '/api/v1/buyer/static/template/view/'

//Membership pdf
export const membershipPdfView = "/api/v1/buyer/membership/invoice/pdf";

// Membership invoice
export const premierInvoiceView = "/api/v1/buyer/user/invoice/list";

// Sneak peak
export const sneakpeekList = "/api/v1/buyer/sneakpeek/sale/list";

// News and stories
export const newsandstories = "/api/v1/buyer/blog/content/list";
